import { useState } from "react";
import { useNavigate } from "react-router-dom";

// A simple product preview layout
function SimpleProductPreview({ product }) {
  if (!product) return null;

  return (
    <div className="media">
      {/* Image on the left */}
      <div className="w-60px mr-2">
        <img
          src={`/media/${product.product_slug}/${product.cover_image}`}
          alt={product.product_name}
          style={{ maxWidth: "60px", height: "auto" }}
        />
      </div>

      {/* Title & price on the right */}
      <div className="media-body">
        <p
          className="font-weight-bold text-primary mb-0 lh-11 mb-1"
          style={{
            whiteSpace: "normal",
            wordWrap: "break-word",
          }}
        >
          {product.product_name}
        </p>
        <p
          className="text-primary mb-0 lh-1 fs-14"
          style={{
            whiteSpace: "normal",
            wordWrap: "break-word",
          }}
        >
          {Number(product.product_price).toFixed(2)} EUR
        </p>
      </div>
    </div>
  );
}

const PrevAndNextItemNavigation = ({
  direction, // "prev" or "next"
  product,   // the target product for preview and navigation
}) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  // If there's no product to show, render nothing
  if (!product) return null;

  // For the dropdown hover
  const handleMouseEnter = () => setOpen(true);
  const handleMouseLeave = () => setOpen(false);

  // Navigate to the target product’s page
  const handlePreviewClick = () => {
    window.location.href = `/product/${product.product_slug}`
  };

  return (
    <div
      className="dropdown no-caret product-dropdown"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={{ position: "relative" }}
    >
      <button
        onClick={handlePreviewClick}
        className="fs-14 py-3 d-block dropdown-toggle btn btn-link"
        type="button"
        aria-haspopup="true"
        aria-expanded={open ? "true" : "false"}
        style={{ textDecoration: "none" }}
      >
        <i
          className={`far fa-arrow-${direction === "prev" ? "left" : "right"
            }`}
        />
      </button>

      {/* Hover Dropdown Preview */}
      {open && (
        <div
          className="dropdown-menu p-2 border-0 dropdown-menu-right rounded-0"
          style={{
            backgroundColor: "white",
            zIndex: 9999,
            position: "absolute",
            top: "100%",
            right: "0",
            display: "block",
            padding: "10px",
            whiteSpace: "normal",
            wordWrap: "break-word",
          }}
        >
          <button
            onClick={handlePreviewClick}
            style={{
              /* Remove all browser & inherited button styles */
              appearance: 'none',
              background: 'none',
              border: 'none',
              padding: 0,
              margin: 0,
              color: 'inherit',
              font: 'inherit',
              lineHeight: 'inherit',
              textDecoration: 'none',
              cursor: 'pointer',
              outline: 'none',
              display: 'block',
              textAlign: 'left'
            }}
          >
            <SimpleProductPreview product={product} />
          </button>
        </div>
      )}
    </div>
  );
};

export default PrevAndNextItemNavigation;